import { memo } from 'react';
import styles from './visits.module.scss';

export const Visits = memo(({ text }: { text:string }) => {

	function getComplitedAmount():number {
		const curDate:Date = new Date();
		const curHours:number = curDate.getHours();
		const curMinutes:number = curDate.getMinutes();
		return Math.floor((curHours*60 + curMinutes)/45 * 10);
	}

	return (
		<div className={styles.visits}>
			{text}: <b>{getComplitedAmount()}</b>
		</div>
	);
  
});